import { Menu, MenuProps } from 'antd';
import styled from 'styled-components';

const StyledSubmissionMenuElement = styled(Menu)`
  &&&.ant-menu-root {
    /* position: sticky;
    top: 0; */
    border-inline-end: none;
    > .ant-menu-item {
      padding-left: 12px !important;
      padding-right: 12px !important; // reinserito per allineare icone in menu laterale compilazione
      margin-inline: 0;
      margin-block: 0;
      width: 100%;
    }
    > .ant-menu-submenu {
      margin-bottom: 0;
      > .ant-menu-submenu-title {
        /* height: auto;
        min-height: 40px;
        padding: 4px;
        overflow-wrap: break-word; */

        padding-left: 12px !important;
        padding-right: 12px !important;
        margin-inline: 0;
        margin-block: 0;
        width: 100%;
        /* width: calc(100% - 0px); */
        /* height: auto;
        min-height: 40px; */
      }
      > ul.ant-menu-sub {
        > li.ant-menu-item {
          padding-left: 40px !important;
          margin-top: 0;
          margin-inline: 0;
          margin-block: 0;
          width: 100%;
        }
      }
    }
    .ant-menu-item-icon {
      font-size: 1.3em;
    }
  }
  .ant-menu-submenu-title,
  .ant-menu-item {
    height: auto !important;
    min-height: 40px;
    padding: 4px;
    overflow-wrap: break-word;

    .ant-menu-title-content {
      line-height: 16px;
      display: block;
    }
  }
  // impostazioni per il menu aperto
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: ${({ theme }) => theme.controlItemBgActive};
  }
`;

export function SubmissionMenuStyled(props: MenuProps) {
  return <StyledSubmissionMenuElement {...props} />;
}
